module.exports = __webpack_public_path__ + "src/assets/img/selector-stub-basanov.14db1679.svg";